import type { PortfolioDetailResponseDTO } from "web_myplann/Infrastructure/Api/Api";
import { Resources } from "web_myplann/Infrastructure/Translations/Resources";

const ChartTimeFrameResources = Resources.PortfolioDetail.ChartTimeFrames;

export const ChartTimeFrames = {
	3: ChartTimeFrameResources.threeMonths,
	6: ChartTimeFrameResources.sixMonths,
	12: ChartTimeFrameResources.oneYear,
	36: ChartTimeFrameResources.threeYears,
	60: ChartTimeFrameResources.fiveYears,
	9999: ChartTimeFrameResources.all,
} as const;

export type ChartTimeFrameKey = keyof typeof ChartTimeFrames;

export type PortfolioDetailProps = {
	baseData: PortfolioDetailResponseDTO;
	currencySign: string;
};
